var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeck10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 939 238",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FPSO_FRAMING_LAYOUT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "T/Deck/Alles-Copy",
    transform: "translate(0.287168, 0.434655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "T/Deck/zijdong-Copy-2",
    transform: "translate(182.720917, 14.783542) scale(-1, 1) translate(-182.720917, -14.783542) translate(126.797264, 1.739609)",
    fill: "#D8D8D8",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,26.0878661 L111.847304,26.0878661 L111.847304,9.14644062 L16.6216815,0 L16.6216815,14.4462672 C17.8351699,16.4693876 15.6393001,18.9154342 10.034072,21.784407 C4.42884397,24.6533797 1.0841533,26.0878661 0,26.0878661 Z",
    id: "Path-3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    points: "16.6216815 14.4462672 111.847304 26.0878661 111.847304 20.2670666 26.2518463 13.0439331 26.2518463 6.3576719 111.847304 13.0439331"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 36.5672401,
    cy: 23.6041678,
    rx: 1.97188323,
    ry: 1.97151361
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2",
    transform: "translate(72.995104, 13.561294) rotate(5.000000) translate(-72.995104, -13.561294) translate(42.233891, 10.265943)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.29584431,
    cy: 3.29535148,
    rx: 2.79584431,
    ry: 2.79535148
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    cx: 14.281992,
    cy: 3.29535148,
    rx: 2.79584431,
    ry: 2.79535148
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-4",
    cx: 25.2681397,
    cy: 3.29535148,
    rx: 2.79584431,
    ry: 2.79535148
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-5",
    cx: 36.2542874,
    cy: 3.29535148,
    rx: 2.79584431,
    ry: 2.79535148
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-6",
    cx: 47.2404351,
    cy: 3.29535148,
    rx: 2.79584431,
    ry: 2.79535148
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-7",
    cx: 58.2265828,
    cy: 3.29535148,
    rx: 2.79584431,
    ry: 2.79535148
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy",
    transform: "translate(-0.000000, 155.980556)",
    fill: "#D8D8D8",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.02347788,7.29516122 L55.8664883,7.29740949 L55.8686711,54.7106286 L7.02566059,54.7083803 L7.02347788,7.29516122 Z",
    transform: "translate(31.446074, 31.002895) rotate(-19.000000) translate(-31.446074, -31.002895) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39364326,24.1060176 C12.298384,19.1044096 17.6068071,15.6751546 24.3189126,13.8182526 C31.0310182,11.9613506 36.5341599,11.9613506 40.8283377,13.8182526 C37.1491856,18.2287615 33.1619705,21.249344 28.8666924,22.8800002 C24.5714142,24.5106564 17.7470645,24.9193289 8.39364326,24.1060176 Z",
    id: "Path-3-Copy-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0900776,36.9210783 C17.9948183,31.9194703 23.3032414,28.4902153 30.015347,26.6333133 C36.7274525,24.7764114 42.2305942,24.7764114 46.5247721,26.6333133 C42.8456199,31.0438222 38.8584048,34.0644048 34.5631267,35.695061 C30.2678486,37.3257172 23.4434989,37.7343896 14.0900776,36.9210783 Z",
    id: "Path-3-Copy-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7865119,49.736139 C23.6912526,44.734531 28.9996758,41.3052761 35.7117813,39.4483741 C42.4238868,37.5914721 47.9270285,37.5914721 52.2212064,39.4483741 C48.5420543,43.858883 44.5548391,46.8794655 40.259561,48.5101217 C35.9642829,50.1407779 29.1399332,50.5494504 19.7865119,49.736139 Z",
    id: "Path-3-Copy-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "T/Deck/zijdong",
    transform: "translate(759.121941, 2.739609)",
    fill: "#D8D8D8",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,26.0878661 L111.847304,26.0878661 L111.847304,9.14644062 L16.6216815,0 L16.6216815,14.4462672 C17.8351699,16.4693876 15.6393001,18.9154342 10.034072,21.784407 C4.42884397,24.6533797 1.0841533,26.0878661 0,26.0878661 Z",
    id: "Path-3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    points: "16.6216815 14.4462672 111.847304 26.0878661 111.847304 20.2670666 26.2518463 13.0439331 26.2518463 6.3576719 111.847304 13.0439331"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 36.5672401,
    cy: 23.6041678,
    rx: 1.97188323,
    ry: 1.97151361
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2",
    transform: "translate(72.995104, 13.561294) rotate(5.000000) translate(-72.995104, -13.561294) translate(42.233891, 10.265943)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.29584431,
    cy: 3.29535148,
    rx: 2.79584431,
    ry: 2.79535148
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    cx: 14.281992,
    cy: 3.29535148,
    rx: 2.79584431,
    ry: 2.79535148
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-4",
    cx: 25.2681397,
    cy: 3.29535148,
    rx: 2.79584431,
    ry: 2.79535148
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-5",
    cx: 36.2542874,
    cy: 3.29535148,
    rx: 2.79584431,
    ry: 2.79535148
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-6",
    cx: 47.2404351,
    cy: 3.29535148,
    rx: 2.79584431,
    ry: 2.79535148
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-7",
    cx: 58.2265828,
    cy: 3.29535148,
    rx: 2.79584431,
    ry: 2.79535148
  }))), /*#__PURE__*/React.createElement("g", {
    id: "T/Deck/zijdong-Copy",
    transform: "translate(815.543576, 223.695676) scale(1, -1) translate(-815.543576, -223.695676) translate(759.619924, 210.651743)",
    fill: "#D8D8D8",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,26.0878661 L111.847304,26.0878661 L111.847304,9.14644062 L16.6216815,0 L16.6216815,14.4462672 C17.8351699,16.4693876 15.6393001,18.9154342 10.034072,21.784407 C4.42884397,24.6533797 1.0841533,26.0878661 0,26.0878661 Z",
    id: "Path-3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    points: "16.6216815 14.4462672 111.847304 26.0878661 111.847304 20.2670666 26.2518463 13.0439331 26.2518463 6.3576719 111.847304 13.0439331"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 36.5672401,
    cy: 23.6041678,
    rx: 1.97188323,
    ry: 1.97151361
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2",
    transform: "translate(72.995104, 13.561294) rotate(5.000000) translate(-72.995104, -13.561294) translate(42.233891, 10.265943)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.29584431,
    cy: 3.29535148,
    rx: 2.79584431,
    ry: 2.79535148
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    cx: 14.281992,
    cy: 3.29535148,
    rx: 2.79584431,
    ry: 2.79535148
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-4",
    cx: 25.2681397,
    cy: 3.29535148,
    rx: 2.79584431,
    ry: 2.79535148
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-5",
    cx: 36.2542874,
    cy: 3.29535148,
    rx: 2.79584431,
    ry: 2.79535148
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-6",
    cx: 47.2404351,
    cy: 3.29535148,
    rx: 2.79584431,
    ry: 2.79535148
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-7",
    cx: 58.2265828,
    cy: 3.29535148,
    rx: 2.79584431,
    ry: 2.79535148
  }))), /*#__PURE__*/React.createElement("g", {
    id: "T/Deck/zijdong-Copy-3",
    transform: "translate(182.720917, 222.996931) scale(-1, -1) translate(-182.720917, -222.996931) translate(126.797264, 209.952998)",
    fill: "#D8D8D8",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,26.0878661 L111.847304,26.0878661 L111.847304,9.14644062 L16.6216815,0 L16.6216815,14.4462672 C17.8351699,16.4693876 15.6393001,18.9154342 10.034072,21.784407 C4.42884397,24.6533797 1.0841533,26.0878661 0,26.0878661 Z",
    id: "Path-3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    points: "16.6216815 14.4462672 111.847304 26.0878661 111.847304 20.2670666 26.2518463 13.0439331 26.2518463 6.3576719 111.847304 13.0439331"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 36.5672401,
    cy: 23.6041678,
    rx: 1.97188323,
    ry: 1.97151361
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2",
    transform: "translate(72.995104, 13.561294) rotate(5.000000) translate(-72.995104, -13.561294) translate(42.233891, 10.265943)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.29584431,
    cy: 3.29535148,
    rx: 2.79584431,
    ry: 2.79535148
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    cx: 14.281992,
    cy: 3.29535148,
    rx: 2.79584431,
    ry: 2.79535148
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-4",
    cx: 25.2681397,
    cy: 3.29535148,
    rx: 2.79584431,
    ry: 2.79535148
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-5",
    cx: 36.2542874,
    cy: 3.29535148,
    rx: 2.79584431,
    ry: 2.79535148
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-6",
    cx: 47.2404351,
    cy: 3.29535148,
    rx: 2.79584431,
    ry: 2.79535148
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-7",
    cx: 58.2265828,
    cy: 3.29535148,
    rx: 2.79584431,
    ry: 2.79535148
  }))), /*#__PURE__*/React.createElement("g", {
    id: "T/Deck",
    transform: "translate(12.462582, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "T/Deck-Copy",
    transform: "translate(0.368620, 30.112964)",
    fill: "#EDEEF4",
    stroke: "#8993A4",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    x: 0,
    y: 0,
    width: 922.599861,
    height: 178.352381,
    rx: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "T/Deck/Piping",
    transform: "translate(152.429453, 106.132012)",
    opacity: 0.547688802,
    stroke: "#FFEE00",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-27",
    x: 0,
    y: 0,
    width: 757.379917,
    height: 21.9285714,
    rx: 9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-28",
    x: 7.31061696,
    y: 7.30952381,
    width: 741.29656,
    height: 7.30952381,
    rx: 3.6547619
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "#979797",
    strokeWidth: 2,
    fill: "#D8D8D8",
    x: 59.8535562,
    y: 50.117726,
    width: 46.250072,
    height: 138.342857,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "T/Deck/Heli",
    transform: "translate(0.002525, -0.002525)",
    fill: "#D8D8D8",
    stroke: "#979797",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.375712,12.4467422 C47.6207161,12.3452582 47.895998,12.3452479 48.1410097,12.4467136 L48.1410097,12.4467136 L72.4560308,22.5161952 C72.7010904,22.6176807 72.8957921,22.8123679 72.9972959,23.0574199 L72.9972959,23.0574199 L83.067728,47.3695936 C83.1692319,47.6146456 83.1692216,47.8899851 83.0676994,48.1350295 L83.0676994,48.1350295 L72.9945818,72.4485444 C72.8930795,72.693541 72.6984185,72.8881874 72.4534144,72.9896715 L72.4534144,72.9896715 L48.1370521,83.0618385 C47.8920479,83.1633225 47.616766,83.1633328 47.3717543,83.0618671 L47.3717543,83.0618671 L23.0567333,72.9923855 C22.8116737,72.8909 22.616972,72.6962129 22.5154681,72.4511608 L22.5154681,72.4511608 L12.445036,48.1389872 C12.3435322,47.8939351 12.3435425,47.6185957 12.4450647,47.3735512 L12.4450647,47.3735512 L22.5181822,23.0600363 C22.6196846,22.8150397 22.8143455,22.6203933 23.0593497,22.5189093 L23.0593497,22.5189093 Z",
    id: "Polygon-Copy",
    transform: "translate(47.756382, 47.754290) rotate(22.500000) translate(-47.756382, -47.754290) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "T/hel",
    transform: "translate(47.887631, 48.386774) rotate(45.000000) translate(-47.887631, -48.386774) translate(33.997459, 34.498678)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "H",
    transform: "translate(8.772740, 7.309524)",
    fill: "#2F2F2F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.419305405,13.1571429 C0.292243161,13.1571429 0.190593366,13.1164184 0.11435602,13.0349694 C0.0381186732,12.9535204 0,12.8501429 0,12.7248367 L0,0.451102041 C0,0.313265306 0.0381186732,0.203622449 0.11435602,0.122173469 C0.190593366,0.0407244898 0.292243161,0 0.419305405,0 L1.33415356,0 C1.47392203,0 1.58510149,0.0407244898 1.66769195,0.122173469 C1.75028241,0.203622449 1.79157764,0.313265306 1.79157764,0.451102041 L1.79157764,5.67636735 L8.42422677,5.67636735 L8.42422677,0.451102041 C8.42422677,0.313265306 8.465522,0.203622449 8.54811246,0.122173469 C8.63070292,0.0407244898 8.73552927,0 8.86259151,0 L9.77743967,0 C9.91720814,0 10.0283876,0.0407244898 10.1109781,0.122173469 C10.1935685,0.203622449 10.2348637,0.313265306 10.2348637,0.451102041 L10.2348637,12.7248367 C10.2348637,12.8501429 10.190392,12.9535204 10.1014484,13.0349694 C10.0125048,13.1164184 9.90450191,13.1571429 9.77743967,13.1571429 L8.86259151,13.1571429 C8.73552927,13.1571429 8.63070292,13.1164184 8.54811246,13.0349694 C8.465522,12.9535204 8.42422677,12.8501429 8.42422677,12.7248367 L8.42422677,7.31161224 L1.79157764,7.31161224 L1.79157764,12.7248367 C1.79157764,12.8501429 1.74710585,12.9535204 1.65816228,13.0349694 C1.56921871,13.1164184 1.46121581,13.1571429 1.33415356,13.1571429 L0.419305405,13.1571429 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#000000",
    cx: 13.8901722,
    cy: 13.8880952,
    rx: 13.3901722,
    ry: 13.3880952
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M878.449057,21.2767888 C917.775527,25.0855255 937.438762,41.5462582 937.438762,70.6589871 C937.438762,114.32808 937.438762,131.818771 937.438762,174.751649 C937.438762,203.373568 919.65043,219.548614 884.073765,223.276789 L884.073765,195.454915 L894.055065,183.162351 L894.055065,155.766218 L899.529161,146.385051 L899.529161,99.0609089 L894.055065,89.6797413 L894.055065,59.9132185 L884.073765,48.2620538 L884.073765,29.834362 L878.449057,29.834362 L878.449057,21.2767888 Z",
    id: "Path-2",
    stroke: "#979797",
    fill: "#D8D8D8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeck10);
export default __webpack_public_path__ + "static/media/deck10.f74fca08.svg";
export { ForwardRef as ReactComponent };